import React from "react";
import EditCustomer from "../../../Features/Forms/Customers/Edit";

const Edit = () => {
  return (
    <div>
      <EditCustomer />
    </div>
  );
};

export default Edit;
